module.exports = __webpack_public_path__ + "static/wcswr-logo-d50778c9c4d2025a3286c6c57e19e1b0.png";